module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate-new/student-org-promo-b536d256f64d602bc20872f7cc3bfc7e.jpg";